import React, { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { CarFront, X } from 'lucide-react';

// "Trenažér (sériové číslo)": the machines of this customer the job is paired with.
const UpgradeMachinesCard = ({ job, form, set, locked }) => {
  const [customerMachines, setCustomerMachines] = useState([]);

  useEffect(() => {
    if (!job.customer_id) return undefined;
    let cancelled = false;
    fetch(`/api/machines?customer_id=${job.customer_id}&limit=200`, { credentials: 'include' })
      .then((r) => r.json())
      .then((j) => { if (!cancelled) setCustomerMachines(j.data || []); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [job.customer_id]);

  const known = useMemo(() => {
    const map = new Map(customerMachines.map((m) => [m.id, m]));
    job.machines.forEach((m) => map.set(m.machine_id, { id: m.machine_id, serial_number: m.serial_number, model_type: m.model_type }));
    return map;
  }, [customerMachines, job.machines]);

  const selected = form.machine_ids.map((id) => known.get(id) || { id, serial_number: `#${id}`, model_type: '' });
  const available = customerMachines.filter((m) => !form.machine_ids.includes(m.id) && m.status !== 'nahled');
  const remove = (id) => set('machine_ids', form.machine_ids.filter((x) => x !== id));
  const add = (value) => { if (value) set('machine_ids', [...form.machine_ids, Number(value)]); };

  return (
    <section className="dlv-card" aria-labelledby="upg-machines">
      <h2 id="upg-machines" className="upg-card-title"><CarFront size={18} /> Trenažér (sériové číslo)</h2>
      <ul style={{ listStyle: 'none', margin: 0, padding: 0 }}>
        {selected.map((m) => (
          <li key={m.id} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '10px 0', borderBottom: '1px solid var(--dlv-line)' }}>
            <span className="dlv-tag" style={{ background: '#111' }}>{m.model_type || 'TR'}</span>
            <Link className="upg-link" to={`/machines/${m.id}`} style={{ fontWeight: 700 }}>SN {m.serial_number}</Link>
            {m.status && m.status !== 'doruceno' && <span className="upg-tag">{m.status}</span>}
            {!locked && selected.length > 1 && (
              <button type="button" className="dlv-iconbtn" style={{ marginLeft: 'auto' }} onClick={() => remove(m.id)} aria-label={`Odebrat trenažér ${m.serial_number}`}><X size={14} /></button>
            )}
          </li>
        ))}
      </ul>
      {!locked && available.length > 0 && (
        <div style={{ marginTop: 12 }}>
          <label className="dlv-label" htmlFor="upg-add-machine">Přidat další trenažér tohoto zákazníka</label>
          <select id="upg-add-machine" className="dlv-input" value="" onChange={(e) => add(e.target.value)}>
            <option value="">Vybrat podle sériového čísla…</option>
            {available.map((m) => <option key={m.id} value={m.id}>{m.model_type} · SN {m.serial_number}</option>)}
          </select>
        </div>
      )}
      <p className="dlv-hint" style={{ marginTop: 12, marginBottom: 0 }}>Sériové číslo se bere z evidence trenažérů; po dokončení se úprava zobrazí v detailu trenažéru.</p>
    </section>
  );
};

export default UpgradeMachinesCard;
